import * as Icons from "@nova/component-icons"
import { EventKind } from "@nova/schemas"
import { Notification } from "../Notification"
import { AvatarIcon } from "../NotificationIcons"
import { NotificationKindProps } from "./types"

export const AccessRequestedNotification = ({
    notification,
    copy,
    actorName,
}: NotificationKindProps<EventKind.AccessRequested>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <AvatarIcon userId={notification.createdBy} fullName={actorName} />
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
        </Notification.Content>
    </Notification>
)

export const AccessGrantedNotification = ({
    notification,
    copy,
}: NotificationKindProps<EventKind.AccessGranted>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <Icons.NovaPFP className="w-8 h-8 rounded-lg" />
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
            {notification.projectId && (
                <Notification.Action
                    label="Go to project"
                    RightIcon={Icons.ArrowRight}
                    to={{ projectId: notification.projectId }}
                />
            )}
        </Notification.Content>
    </Notification>
)
